import { Injectable, inject } from '@angular/core';
import { SchutzOptimierenKatalogBaseService } from '@comparit/shared';
import type { Observable } from 'rxjs';
import type { HausratBerechnungvorgaben, SchutzOptimierenKatalog } from '../../interfaces';
import { HausratVorgabenService } from '../../interfaces/generated/api/hausrat-vorgaben.service';
import { FormsService } from '../forms.service';

/** Started once from the shell; step 12 and everything after it read `state` and the form. */
@Injectable({ providedIn: 'root' })
export class SchutzOptimierenKatalogService extends SchutzOptimierenKatalogBaseService<
  HausratBerechnungvorgaben,
  SchutzOptimierenKatalog
> {
  private formsService = inject(FormsService);
  private vorgabenService = inject(HausratVorgabenService);

  protected readonly vorgaben$ = this.formsService.vorgabenOhneSchutz$;
  protected readonly form = this.formsService.schutzOptimierenForm;

  /** Step 12 is never invalid, so this is "steps 2–11 complete" — what the backend needs to answer. */
  protected canFetch(): boolean {
    return !this.formsService.isCalculationFormInvalid();
  }

  protected fetchKatalog(
    hausratBerechnungvorgaben: HausratBerechnungvorgaben
  ): Observable<SchutzOptimierenKatalog> {
    return this.vorgabenService.getHausratSchutzOptimierenAttribute({ hausratBerechnungvorgaben });
  }
}
